import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getAPIErrorMessage } from '../../../../helpers/helpers';
import { CompanySpacesService } from '../../../../service/CompanySpacesService';
import {
  NotificationType,
  useNotificationStore,
} from '../../../../store/storeNotifications';

export const useSidebarSpaceActions = (refresh: () => void) => {
  const navigate = useNavigate();
  const location = useLocation();
  const setNotification = useNotificationStore(state => state.setNotification);

  const handleEditSpace = useCallback(
    (spaceId: string) => {
      navigate(`${location.pathname}?space=true&spaceId=${spaceId}`);
      window.dispatchEvent(new CustomEvent('open-settings-modal'));
    },
    [navigate, location.pathname],
  );

  const handleArchiveSpace = useCallback(
    async (spaceId: string) => {
      if (!window.confirm('Are you sure you want to archive this space?'))
        return;
      try {
        await CompanySpacesService.disableSpace(spaceId);
        refresh();
        setNotification({
          type: NotificationType.Success,
          message: 'Space archived successfully',
        });
      } catch (error) {
        setNotification({
          type: NotificationType.Error,
          message: getAPIErrorMessage(error as any),
        });
      }
    },
    [refresh, setNotification],
  );

  return { handleEditSpace, handleArchiveSpace };
};
